export default {
  methods: {
    // 查询数据后，初始化红包Form
    initRedPacketForm(additionalList) {
      const redPacketModule = additionalList.find(item => item.appendName === 'redPacket');
      if (!redPacketModule) {
        return;
      }

      // 红包类型
      const redPacketTypeItem = redPacketModule.activityAppendElement
        .find(item => item.elementCode === 'redPacketType');
      const redPacketType = redPacketTypeItem && redPacketTypeItem.elementValue || 1;

      // 随机红包区间
      const rangeItems = redPacketModule.activityAppendElement.filter(item => !!item.elementGroup)
      const rangeMap = {};
      rangeItems.forEach(item => {
        const key = item.elementGroup;
        if (!rangeMap[key]) {
          rangeMap[key] = {};
        }
        rangeMap[key][item.elementCode] = item.elementValue;
      });

      let form = {};
      redPacketModule.activityAppendElement.forEach(item => {
        const fieldLabel = item.elementCode;
        const fieldValue = item.elementValue;

        // 排除区间字段
        if (!item.elementGroup) {
          form[fieldLabel] = fieldLabel.startsWith('bool') ? fieldValue === 'true' : fieldValue;
        }
      });

      if (redPacketType == 2) {
        form.ranges = Object.values(rangeMap);
      }

      return {
        ...this.additionalForm.redPacket,
        ...form
      };
    },
    // 将红包Form转换为保存时的参数格式
    getRedPacketDTO(redPacketForm) {
      const fields = [];
      if (!redPacketForm) {
        return fields;
      }
      // 未开启
      // if (!redPacketForm.boolShowRedPacket) {
      //   return [
      //     {
      //       elementCode: 'boolShowRedPacket',
      //       elementValue: redPacketForm.boolShowRedPacket
      //     }
      //   ];
      // }
      // 红包类型
      const redPacketType = redPacketForm.redPacketType;
      for (const [key, value] of Object.entries(redPacketForm)) {
        // 普通红包
        if (redPacketType == 1) {
          if (key !== 'ranges') {
            fields.push({
              elementCode: key,
              elementValue: value
            });
          }
        } else if (redPacketType == 2) {
          // 随机红包
          if (key !== 'singleAmount') {
            if (key !== 'ranges') {
              fields.push({
                elementCode: key,
                elementValue: value
              });
            } else {
              redPacketForm.ranges.forEach((item, index) => {
                for (const [rangeKey, rangeValue] of Object.entries(item)) {
                  fields.push({
                    elementCode: rangeKey,
                    elementValue: rangeValue,
                    elementGroup: `range${index}`
                  });
                }
              });
            }
          }
        }
      }
      return fields;
    },
  }
}